/**
 * Cross-section entity references.
 *
 * An entity is addressed by the compact string form `"kind:id"` (e.g. `npc:aldric`,
 * `beast:spettro-baronessa`). References are stored as these strings in frontmatter and
 * embedded in prose as wiki-links `[[kind:id]]` / `[[kind:id|Etichetta]]`.
 */
const REF_RE = /^([a-z][a-z0-9-]*):([a-z0-9][a-z0-9-]*)$/i;
/** True when a string looks like a `kind:id` entity reference. */
export function isRef(value) {
    return typeof value === 'string' && REF_RE.test(value.trim());
}
/** Parse `"kind:id"` into `{kind,id}`; returns null when malformed. */
export function parseRef(value) {
    const m = REF_RE.exec((value ?? '').trim());
    if (!m)
        return null;
    return { kind: m[1].toLowerCase(), id: m[2] };
}
/** Build the compact `"kind:id"` form. */
export function formatRef(kind, id) {
    return `${kind}:${id}`;
}
const WIKILINK_RE = /\[\[\s*([a-z][a-z0-9-]*):([a-z0-9][a-z0-9-]*)\s*(?:\|\s*([^\]]+?)\s*)?\]\]/gi;
/** Extract all `[[kind:id|label]]` wiki-links from a block of text. */
export function extractWikiLinks(text) {
    if (!text)
        return [];
    const out = [];
    let m;
    WIKILINK_RE.lastIndex = 0;
    while ((m = WIKILINK_RE.exec(text)) !== null) {
        out.push({
            raw: m[0],
            kind: m[1].toLowerCase(),
            id: m[2],
            label: m[3]?.trim() || undefined,
            index: m.index,
        });
    }
    return out;
}
/** Collect every `kind:id` referenced by a value (string, ref-array, or counted-ref array). */
export function collectRefs(value) {
    const out = [];
    const push = (s) => {
        if (isRef(s)) {
            const r = parseRef(s);
            if (r)
                out.push(r);
        }
    };
    if (Array.isArray(value)) {
        for (const item of value) {
            if (item && typeof item === 'object' && 'ref' in item) {
                push(item.ref);
            }
            else {
                push(item);
            }
        }
    }
    else {
        push(value);
    }
    return out;
}
//# sourceMappingURL=refs.js.map